import { TextareaProps } from '@chakra-ui/textarea';
import { InputGroup } from '@chakra-ui/react';
import React, { memo } from 'react';

import { Label } from '..';
import * as Styles from './styles';

interface IProps extends TextareaProps {
  inputRef?: React.RefObject<HTMLTextAreaElement>;
  label?: string;
  tip?: string | JSX.Element;
  disabled?: boolean;
}

const TextAreaComponent: React.FC<IProps> = ({ inputRef, label, tip, ...props }) => {
  return (
    <Styles.Container>
      {label && (
        <Label htmlFor={label} tip={tip}>
          {label}
        </Label>
      )}
      <InputGroup>
        <Styles.CustomTextArea ref={inputRef} {...props} />
      </InputGroup>
    </Styles.Container>
  );
};

export const TextArea = memo(TextAreaComponent);
